module.exports = __webpack_public_path__ + "img/account_outer.e6a54244.svg";